import { KeyPlusIcon } from './KeyPlusIcon';

/**
 * author: Austin Andrews
 * id 000AAEC6-5E6C-40F4-B589-AE85920E7EC2
 * name key-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/key-plus.svg
 * tags
 */
export const KeyAddIcon = KeyPlusIcon;
export default KeyAddIcon